module.exports = __webpack_public_path__ + "static/media/globe.d3b8c0b9.png";